export const server_url = 'https://www.creole.tech:3001/transcript/';
